
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/ueberuns/objektakte/objektakte-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="objektakte-view">
        <hero-section
            background-image="/images/hero/objektakte-hero.png"
            headline="Unsere Objektakte"
            subheadline="Objektakte mit FASE2"
            text="Komplett digital in die Zukunft mit unserer Objektakte."
            button-text2="Jetzt kostenlos beraten lassen!"
            button-link2="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="uebersicht-transparenz">
                <hex-headline id="uebersicht-transparenz" left text="Übersicht und Transparenz"></hex-headline>
                <p>
                    Bei <b>FASE2 Facility Services</b> ist es uns wichtig, eine vollständige Übersicht und Transparenz über jedes Objekt zu gewährleisten. 
                    Deshalb führen wir für jedes unserer Objekte eine <b>detaillierte Objektakte</b>. Diese Akte enthält alle relevanten Informationen, 
                    <b>Leistungsanforderungen</b> und individuellen Konzepte, die im Rahmen der Vertragsgestaltung für jedes Projekt erarbeitet werden. 
                    So haben wir stets eine <b>lückenlose Dokumentation</b> und können schnell und effizient auf alle Anforderungen reagieren.
                </p>
            </article>

            <hr>

            <article aria-labelledby="objektaufnahme-konzepte">
                <hex-headline id="objektaufnahme-konzepte" left text="Detaillierte Objektaufnahme und individuelle Konzepte"></hex-headline>
                <p>
                    Zu Beginn jedes Projekts erfolgt eine gründliche <b>Aufnahme des Objekts</b>, 
                    bei der wir alle spezifischen Gegebenheiten und <b>Anforderungen</b> berücksichtigen. 
                    Auf Basis dieser Aufnahme erstellen wir für jedes Objekt ein <b>maßgeschneidertes Konzept</b>, 
                    das genau auf die Bedürfnisse und Ziele des Kunden zugeschnitten ist. 
                    Diese <b>individuelle Planung</b> bildet die Grundlage für unsere Leistungsanforderungen und stellt sicher, 
                    dass alle Arbeiten <b>effizient</b> und nach höchsten Standards ausgeführt werden.
                </p>
            </article>

            <hr>

            <article aria-labelledby="leistungsanforderungen-angebote">
                <hex-headline id="leistungsanforderungen-angebote" left text="Alles im Blick – Leistungs&shy;anforderungen und Angebote"></hex-headline>
                <p>
                    Im Rahmen unserer <b>Angebotsgestaltung</b> werden die definierten Leistungsanforderungen klar festgehalten und für alle Beteiligten transparent gemacht. 
                    Wir wissen genau, welche <b>Leistungen</b> für jedes Objekt erforderlich sind und stellen sicher, dass alle Partner die gleichen <b>Informationen</b> haben. 
                    Dadurch können wir alle Arbeitsprozesse optimal koordinieren und sicherstellen, dass keine Details übersehen werden. 
                    So haben sowohl wir als auch unsere Partner zu <b>jeder Zeit</b> einen klaren Überblick und arbeiten <b>effizient und zielgerichtet</b>.
                </p>
            </article>

            <hr>

            <article aria-labelledby="flexibilitaet-kunden">
                <hex-headline id="flexibilitaet-kunden" left text="Flexibilität für unsere Kunden – Leistungen hinzubuchen oder auslösen"></hex-headline>
                <p>
                    Ein weiteres <b>Highlight</b> der Objektakte ist die <b>Flexibilität</b>, die wir unseren Kunden bieten. 
                    Während der Vertragslaufzeit haben unsere Kunden jederzeit die Möglichkeit, <b>zusätzliche Leistungen</b> hinzuzufügen 
                    oder bestehende Leistungen anzupassen - ganz nach Bedarf. Wenn beispielsweise eine zusätzliche <b>Sanierung</b> oder 
                    Reparaturmaßnahme erforderlich wird, können diese Leistungen einfach und schnell in der <b>Objektakte</b> erfasst und ausgeführt werden. 
                    Wir reagieren flexibel auf Ihre <b>Wünsche</b> und sorgen dafür, dass Ihr Objekt immer <b>optimal betreut</b> wird.
                </p>
            </article>

            <hr>

            <article aria-labelledby="transparenz-kontrolle">
                <hex-headline id="transparenz-kontrolle" left text="Transparenz und Kontrolle für Mieter, Eigentümer und Verwalter"></hex-headline>
                <p>
                    Die <b>Objektakte</b> sorgt nicht nur bei uns für eine strukturierte und <b>effiziente Arbeitsweise</b>, sondern ermöglicht es auch unseren Kunden, 
                    den aktuellen Stand der Arbeiten und die erbrachten <b>Leistungen</b> jederzeit einzusehen. Mieter, 
                    Eigentümer und <b>Verwalter</b> können jederzeit auf die Dokumentation zugreifen und sich über alle <b>relevanten Details</b> informieren. 
                    Dies schafft Vertrauen und sorgt für eine <b>klare Kommunikation</b> zwischen allen Beteiligten.
                </p>
            </article>

            <hr>

            <aside aria-labelledby="vorteile-objektakte">
                <hex-headline id="vorteile-objektakte" left text="Vorteile der Objektakte auf einen Blick"></hex-headline>
                <ul>
                    <li><strong>Individuelle Konzepte:</strong> Leistungsanforderungen für jedes Objekt.</li>
                    <li><strong>Detaillierte Dokumentation:</strong> Alle Objektinformationen auf einen Blick.</li>
                    <li><strong>Transparente Angebotsgestaltung:</strong> Klare Übersicht für alle Beteiligten.</li>
                    <li><strong>Flexibilität:</strong> Leistungen nach Bedarf hinzufügen oder ändern.</li>
                    <li><strong>Zugriff für alle:</strong> Transparenz für Mieter, Eigentümer und Verwalter.</li>
                </ul>
            </aside>

            <hr>

            <article aria-labelledby="koordination-partner">
                <hex-headline id="koordination-partner" left text="Optimale Koordination aller Partner durch klare, strukturierte Daten"></hex-headline>
                <p>
                    Mit der <b>Objektakte</b> bieten wir Ihnen bei FASE2 Facility Services eine <b>maßgeschneiderte, 
                    transparente und flexible Lösung</b> für das Management Ihrer <b>Immobilien</b>. Wir stellen sicher, 
                    dass alle relevanten Informationen jederzeit verfügbar sind und Sie die <b>Kontrolle über alle Leistungen</b> behalten - effizient, 
                    übersichtlich und <b>zuverlässig</b>.
                </p>
            </article>
        </div>
    </section>`,
      style: `objektakte-view .objektakte-view {
  margin: 0;
  padding: 0;
}
objektakte-view .objektakte-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
objektakte-view .objektakte-view .wrapper article {
  margin: 96px 0 0 0;
  padding: 0;
}
objektakte-view .objektakte-view .wrapper article:first-of-type {
  margin: 0 0 0 0;
}
objektakte-view .objektakte-view .wrapper aside {
  margin: 96px 0 0 0;
  padding: 0;
}
@media (max-width: 992px) {
  objektakte-view .objektakte-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  